import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon_arrow-right",
  "use": "icon_arrow-right-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" id=\"icon_arrow-right\"><path fill=\"currentColor\" d=\"M4 11.5h-.5v1H4v-1Zm0 1h16v-1H4v1Z\" /><path stroke=\"currentColor\" stroke-linecap=\"square\" d=\"m14.2715 6 5.7273 6-5.7273 6\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol